var Cart = /** @class */ (function () {
    function Cart(props) {
        Object.assign(this, props);
        if (props.contact) {
            this.name = props.contact.name + ' ' + props.contact.surname;
            this.telephone = props.contact.telephone;
            this.email = props.contact.email;
        }
    }
    return Cart;
}());
export default Cart;
var Contact = /** @class */ (function () {
    function Contact() {
    }
    return Contact;
}());
export { Contact };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Carts/Cart.ts
// module id = 743
// module chunks = 0